<script setup lang="ts">
import { mdiLock } from "@mdi/js";
import EventPrice from "./EventPrice.vue";
import { IMarket } from "~/types/sports/market";
import { useBetbook } from "~/store/betbook";
import { IOutcome } from "~/types/sports/outcome";

interface Props {
	market: IMarket | undefined;
	outcome: IOutcome | undefined;
	eventId: number;
	isStartingPrice?: boolean;
}

const props = defineProps<Props>();
const store = useBetbook();
const event = computed(() => store.events.get(props.eventId));
const isDisabled = computed(() => {
	return (
		!props.market ||
		!props.outcome?.isTradingActive ||
		props.market.isSuspended ||
		!event.value?.isActive ||
		!event.value?.shouldDisplay ||
		!props.market.shouldDisplay
	);
});
</script>

<template>
	<div v-if="!isDisabled && outcome" class="relative flex gap-1 md:items-center w-[50px]">
		<EventPrice
			:isStartingPrice="isStartingPrice"
			:price="store.prices.get(outcome.outcomeId)"
			:outcome="outcome"
			:eventId="eventId"
			:market="market"
		/>
	</div>
	<div
		v-else-if="event?.isActive && !outcome?.isTradingActive"
		class="flex font-light h-[32px] items-center justify-center rounded-md cursor-pointer w-[50px] text-xs"
	>
		NR
	</div>
	<div
		v-else
		:class="[
			'flex h-[32px] items-center justify-center rounded-md border border-light-500 dark:border-dark-400 cursor-pointer  w-[50px]',
			market?.isSuspended && 'bg-light-500 dark:bg-dark-400',
		]"
	>
		<UiIcon class="w-4 h-4 dark:fill-light-500" :path="mdiLock" />
	</div>
</template>
